import { cloneVehicleInto, type VehicleInput, type VehicleState } from '../game/vehicle';
import { integrateGroundStep } from '../game/groundStep';

export type PendingFrame = {
  seq: number;
  dt: number;
  input: VehicleInput;
};

/**
 * prd2 Week 3 Day 16 — client prediction reconciliation.
 * Reset to authoritative snapshot (after ack), then replay unconfirmed inputs in order.
 */
export function reconcileGroundVehicle(
  vehicle: VehicleState,
  authoritative: VehicleState,
  ackSeq: number,
  pending: PendingFrame[],
): void {
  for (let i = pending.length - 1; i >= 0; i--) {
    if (pending[i].seq <= ackSeq) pending.splice(i, 1);
  }

  cloneVehicleInto(vehicle, authoritative);

  const ordered = [...pending].sort((a, b) => a.seq - b.seq);
  for (const p of ordered) {
    integrateGroundStep(vehicle, p.input, p.dt);
  }
}
